var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, MenuItem, Typography, } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import { Loading } from 'components/widgets/Loading';
import { Field, Formik } from 'formik';
import { Select, TextField } from 'formik-mui';
import { Role, VerificationMethodType } from 'lib/api/api-types';
import { ClientLogger } from 'lib/client-logger';
import { useErrorHandler } from 'lib/use-error-handler';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { usePersonOrgService } from 'ui-lib';
import { EmailOnlyField, RoleSelector, SEVERITY, ToastDispatchContext, VerificationMethodSelector, YearMonthDay, } from 'ui-lib';
import makeStyles from '@mui/styles/makeStyles';
import CloseIcon from '@mui/icons-material/Clear';
import { dialogClasses } from '../../style/sharedCssClasses';
import { theme } from 'style/theme';
import { EnumGenderTypes } from 'lib/enums';
import { useVeridApi } from 'ui-lib';
var useClasses = makeStyles(__assign({}, dialogClasses));
var DEBUG = false;
export function EditPersonOrg(props) {
    var classes = useClasses();
    var personOrgService = usePersonOrgService();
    var errorHandler = useErrorHandler('EditOrg');
    var formRef = useRef(null);
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(false), editingPersonDetails = _b[0], setEditingPersonDetails = _b[1];
    var _c = useState(false), viewPersonVerifications = _c[0], setViewPersonVerifications = _c[1];
    var _d = useState(false), editingRole = _d[0], setEditingRole = _d[1];
    var _e = useState(false), editingEmail = _e[0], setEditingEmail = _e[1];
    var _f = useState([]), personOrgVerifications = _f[0], setPersonOrgVerifications = _f[1];
    var toastDispatch = useContext(ToastDispatchContext);
    var veridApolloClient = useVeridApi().clientWithAuth;
    var editingId = props.editingId, onClose = props.onClose, orgId = props.orgId;
    useEffect(function () {
        DEBUG && ClientLogger.debug('EditPersonOrg', 'useEffect', { props: props });
        if (formRef.current) {
            if (editingId) {
                personOrgService
                    .personOrg(editingId)
                    .then(function (resp) {
                    var _a, _b;
                    var personOrg = (_a = resp.data) === null || _a === void 0 ? void 0 : _a.personOrg; //Util.convertBlanks(resp.data.personOrg, null, '');
                    DEBUG && ClientLogger.debug('EditPersonOrg', 'load personOrg', { resp: resp, personOrg: personOrg });
                    if (personOrg) {
                        var verification = personOrg.verificationsOf[0];
                        (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.setValues({
                            id: personOrg.id,
                            role: personOrg.role,
                            email: personOrg.email,
                            title: verification === null || verification === void 0 ? void 0 : verification.title,
                            firstName: verification === null || verification === void 0 ? void 0 : verification.firstName,
                            middleName: verification === null || verification === void 0 ? void 0 : verification.middleName,
                            lastName: verification === null || verification === void 0 ? void 0 : verification.lastName,
                            gender: verification === null || verification === void 0 ? void 0 : verification.gender,
                            dateOfBirth: verification === null || verification === void 0 ? void 0 : verification.dateOfBirth,
                            // isSysAccount: verification?.systemAccount || false,
                            verification: undefined,
                            idTypes: [],
                        });
                        personOrgService
                            .personOrgVerifications(personOrg.orgId, personOrg.personId)
                            .then(function (response) {
                            var _a;
                            var personVerificationsData = (_a = response.data) === null || _a === void 0 ? void 0 : _a.personOrgVerifications;
                            if (personVerificationsData) {
                                setPersonOrgVerifications(personVerificationsData);
                            }
                            else {
                                errorHandler.handleErrors({ graphQLErrors: response.errors });
                            }
                        })
                            .catch(function (error) {
                            errorHandler.handleErrors({ error: error });
                            setLoading(false);
                        });
                    }
                    else {
                        errorHandler.handleErrors({ graphQLErrors: resp.errors });
                    }
                    setLoading(false);
                })
                    .catch(function (err) {
                    errorHandler.handleErrors({ error: err });
                    setLoading(false);
                });
            }
            else {
                setLoading(false);
            }
        }
    }, [editingId]);
    var scenarioDataTableOptions = {
        pagination: false,
        download: false,
        print: false,
        filter: false,
        search: false,
        viewColumns: false,
        sort: true,
        selectableRows: 'none',
        textLabels: {
            body: {
                noMatch: 'No Mapping Found',
            },
        },
    };
    var columns = [
        { name: 'createdAt', label: 'Created At' },
        { name: 'createdBy', label: 'Created By' },
        { name: 'methodType', label: 'Method Type' },
        { name: 'personId', label: 'Person ID' },
        { name: 'title', label: 'Title' },
        { name: 'firstName', label: 'First Name' },
        { name: 'middleName', label: 'Middle Name' },
        { name: 'lastName', label: 'Last Name' },
        { name: 'dateOfBirth', label: 'Date Of Birth' },
        { name: 'gender', label: 'Gender' },
        { name: 'status', label: 'Status' },
    ];
    var data = personOrgVerifications.map(function (personOrgVerification) { return ({
        createdAt: personOrgVerification.createdAt,
        // createdBy: personOrgVerification.createdBy.email,
        methodType: personOrgVerification.method.type,
        // personId: personOrgVerification.person.id,
        title: personOrgVerification.title,
        firstName: personOrgVerification.firstName,
        middleName: personOrgVerification.middleName,
        lastName: personOrgVerification.lastName,
        dateOfBirth: personOrgVerification.dateOfBirth,
        gender: personOrgVerification.gender,
        // status: personOrgVerification.person.status,
    }); });
    function savePerson(values) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var verification, verificationInput, resp;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!((_a = values.verification) === null || _a === void 0 ? void 0 : _a.passed)) {
                            toastDispatch({
                                severity: SEVERITY.ERROR,
                                msg: 'Verification method must be selected and verified',
                            });
                            return [2 /*return*/];
                        }
                        if (!values.verification) return [3 /*break*/, 2];
                        verification = values.verification;
                        verificationInput = {
                            methodId: verification.id,
                            passed: verification.passed,
                            idTypes: values.idTypes && values.idTypes.length > 0
                                ? values.idTypes.map(function (idType) { return ({
                                    id: idType.id,
                                    idNumber: idType.idNumber,
                                    idExpiry: idType.idExpiry,
                                }); })
                                : undefined,
                            title: values.title,
                            firstName: values.firstName,
                            middleName: values.middleName,
                            lastName: values.lastName,
                        };
                        return [4 /*yield*/, personOrgService.personOrgUpdate({
                                personOrgId: values.id,
                                verification: verificationInput,
                            })];
                    case 1:
                        resp = _c.sent();
                        if ((_b = resp.data) === null || _b === void 0 ? void 0 : _b.personOrgUpdate.id) {
                            toastDispatch({
                                severity: SEVERITY.SUCCESS,
                                msg: 'Person updated',
                            });
                            onClose();
                        }
                        else {
                            errorHandler.handleMutateResponse(resp);
                        }
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function updatePersonOrgRole(values) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, personOrgService.personOrgChangeRole({
                            id: values.id,
                            orgId: orgId,
                            role: values.role,
                        })];
                    case 1:
                        resp = _b.sent();
                        if ((_a = resp.data) === null || _a === void 0 ? void 0 : _a.personOrgChangeRole.success) {
                            toastDispatch({
                                severity: SEVERITY.SUCCESS,
                                msg: 'User Updated',
                            });
                            setEditingRole(false);
                            onClose();
                        }
                        else {
                            errorHandler.handleMutateResponse(resp);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    DEBUG && ClientLogger.debug('EditPersonOrg', 'render', { props: props, formRef: JSON.stringify(formRef.current) });
    return (_jsx(Formik, __assign({ innerRef: formRef, initialValues: {
            id: '',
            role: Role.USER,
            email: '',
            title: '',
            firstName: '',
            middleName: '',
            lastName: '',
            dateOfBirth: undefined,
            gender: '',
            isSysAccount: false,
            verification: {
                // @ts-ignore TODO - upgrade: why?
                id: '',
                // @ts-ignore TODO - upgrade
                idTypes: [],
                // @ts-ignore TODO - upgrade
                passed: false,
                // @ts-ignore TODO - upgrade
                verificationMethodType: VerificationMethodType.PERSONAL_KNOWLEDGE,
            },
            idTypes: [],
        }, validate: function (values) {
            var errors = {};
            return errors;
        }, onSubmit: function () { } }, { children: function (_a) {
            var _b, _c;
            var submitForm = _a.submitForm, isSubmitting = _a.isSubmitting, errors = _a.errors, values = _a.values, setFieldValue = _a.setFieldValue, touched = _a.touched, setFieldError = _a.setFieldError, setFieldTouched = _a.setFieldTouched, dirty = _a.dirty;
            if (loading) {
                return _jsx(Loading, {});
            }
            return (_jsxs(_Fragment, { children: [_jsxs(DialogTitle, __assign({ className: classes.dialogTitle }, { children: ["Edit Person", _jsx(IconButton, __assign({ onClick: onClose, size: "large" }, { children: _jsx(CloseIcon, { className: classes.closeIcon }) }))] })), _jsxs(DialogContent, { children: [editingPersonDetails === false ? (_jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "h6" }, { children: "Person Details" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsxs(Grid, __assign({ size: 9 }, { children: [_jsxs(Typography, __assign({ variant: "body2" }, { children: ["Title: ", values.title] })), _jsxs(Typography, __assign({ variant: "body2" }, { children: ["First Name: ", values.firstName] })), _jsxs(Typography, __assign({ variant: "body2" }, { children: ["Middle Name: ", values.middleName] })), _jsxs(Typography, __assign({ variant: "body2" }, { children: ["Last Name: ", values.lastName] })), _jsxs(Typography, __assign({ variant: "body2" }, { children: ["Gender: ", values.gender] })), _jsxs(Typography, __assign({ variant: "body2" }, { children: ["Date of Birth: ", values.dateOfBirth] })), values.isSysAccount && _jsxs(Typography, __assign({ variant: "body2" }, { children: ["System Account: ", "".concat(values.isSysAccount)] }))] })), _jsxs(Grid, __assign({ size: 3 }, { children: [_jsx(Button, __assign({ variant: "contained", className: classes.btnSpacing, onClick: function () { return setEditingPersonDetails(true); } }, { children: "Edit" })), _jsx(Button, __assign({ variant: "contained", className: classes.btnSpacing, onClick: function () { return setViewPersonVerifications(true); } }, { children: "History" }))] }))] }))] })) : (_jsxs(_Fragment, { children: [_jsx(VerificationMethodSelector, { baseName: "verification", baseNameIdTypes: "idTypes", orgId: props.orgId, setFieldValue: setFieldValue, readFromVerid: true, style: {
                                            inputField: {
                                                width: '100%',
                                                marginTop: '12px',
                                            },
                                        } }), _jsx(Field, { component: TextField, name: "title", label: "Title", placeholder: "Enter the tite (Mr. Ms. etc)", type: "text", fullWidth: true, variant: "outlined", className: classes.inputField, "data-test": "name-textfield" }), _jsx(Field, { component: TextField, name: "firstName", label: "First Name", placeholder: "Enter the first name", type: "text", fullWidth: true, variant: "outlined", className: classes.inputField, "data-test": "new-patient-middle-name-textfield" }), _jsx(Field, { component: TextField, name: "middleName", label: "Middle Name", placeholder: "Enter the middle name", type: "text", fullWidth: true, variant: "outlined", className: classes.inputField, "data-test": "name-textfield" }), _jsx(Field, { component: TextField, name: "lastName", label: "Last Name", placeholder: "Enter the last name", type: "text", fullWidth: true, variant: "outlined", className: classes.inputField, "data-test": "name-textfield" }), _jsx(Grid, __assign({ sx: dialogClasses.caption }, { children: _jsx(Typography, __assign({ color: "textPrimary", align: "left", variant: "caption" }, { children: "Date of Birth" })) })), _jsxs(Grid, __assign({ container: true }, { children: [_jsx(Box, __assign({ mt: 1, sx: __assign({}, (((_b = errors.dateOfBirth) === null || _b === void 0 ? void 0 : _b.length) && dialogClasses.errorBlock)) }, { children: _jsx(YearMonthDay, { readonly: false, theme: theme, dateFieldName: "dateOfBirth", value: values.dateOfBirth, errors: errors, touched: touched, setFieldValue: setFieldValue }) })), ((_c = errors.dateOfBirth) === null || _c === void 0 ? void 0 : _c.length) && (_jsx(Grid, { children: _jsx(Typography, __assign({ align: "left", variant: "caption" }, { children: errors.dateOfBirth })) }))] })), _jsx(Grid, __assign({ container: true }, { children: _jsx(Grid, __assign({ size: "grow" }, { children: _jsx(Box, __assign({ mt: 1 }, { children: _jsx(FormControl, __assign({ sx: dialogClasses.fullWidthField, fullWidth: true }, { children: _jsxs(Field, __assign({ component: Select, name: "gender", inputProps: {
                                                            id: 'gender',
                                                        }, label: "Sex", variant: "outlined", disabled: false, "data-test": "new-patient-gender-textfield" }, { children: [_jsx(MenuItem, __assign({ value: EnumGenderTypes.M }, { children: "Male" })), _jsx(MenuItem, __assign({ value: EnumGenderTypes.F }, { children: "Female" })), _jsx(MenuItem, __assign({ value: EnumGenderTypes.U }, { children: "Other" }))] })) })) })) })) })), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ color: "primary", disabled: isSubmitting, onClick: function () { return setEditingPersonDetails(false); } }, { children: "Cancel" })), _jsx(Button, __assign({ type: "submit", color: "primary", disabled: isSubmitting, onClick: function () {
                                                    savePerson(values);
                                                } }, { children: "Save" }))] })] })), editingRole === false ? (_jsxs(Box, __assign({ mt: 2 }, { children: [_jsx(Typography, __assign({ variant: "h6" }, { children: "Role" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ size: 9 }, { children: _jsxs(Typography, __assign({ variant: "body2" }, { children: ["Role: ", values.role] })) })), _jsx(Grid, __assign({ size: 3 }, { children: _jsx(Button, __assign({ variant: "contained", onClick: function () { return setEditingRole(true); } }, { children: "Edit" })) }))] }))] }))) : (_jsxs(_Fragment, { children: [_jsx(RoleSelector, { name: "role" }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ color: "primary", disabled: isSubmitting, onClick: function () { return setEditingRole(false); } }, { children: "Cancel" })), _jsx(Button, __assign({ type: "submit", color: "primary", disabled: isSubmitting, onClick: function () {
                                                    updatePersonOrgRole(values);
                                                } }, { children: "Save" }))] })] })), editingEmail === false ? (_jsxs(Box, __assign({ mt: 2 }, { children: [_jsx(Typography, __assign({ variant: "h6" }, { children: "Email" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ size: 9 }, { children: _jsxs(Typography, __assign({ variant: "body2" }, { children: ["Email Address: ", values.email] })) })), _jsx(Grid, __assign({ size: 3 }, { children: _jsx(Button, __assign({ variant: "contained", onClick: function () { return alert('to do'); } }, { children: "Edit" })) }))] }))] }))) : (_jsxs(_Fragment, { children: [_jsx(EmailOnlyField, {}), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ color: "primary", disabled: isSubmitting, onClick: function () { return setEditingRole(false); } }, { children: "Cancel" })), _jsx(Button, __assign({ type: "submit", color: "primary", disabled: isSubmitting }, { children: "Save" }))] })] }))] }), _jsx(DialogActions, { children: _jsx(Button, __assign({ color: "primary", disabled: isSubmitting, onClick: function () { return onClose(); } }, { children: "Done" })) }), _jsx(Dialog, __assign({ open: viewPersonVerifications, onClose: function () { return setViewPersonVerifications(false); }, maxWidth: "lg", fullWidth: true }, { children: _jsxs(_Fragment, { children: [_jsx(MUIDataTable, { title: "Person Verifications History", options: scenarioDataTableOptions, columns: columns, data: data }), _jsx(DialogActions, { children: _jsx(Button, __assign({ color: "primary", disabled: isSubmitting, onClick: function () { return setViewPersonVerifications(false); } }, { children: "Back To Edit Person" })) })] }) }))] }));
        } })));
}
